export default __webpack_public_path__ + "btn-edit.png?340f5f3f5cc367482de562932b109cb1";